import React from "react";
import "./home.css";
import facebook from "../../assets/facebook.png";
import instagram from "../../assets/instagram.png";
import github from "../../assets/github.png";
import Typical from "react-typical";
import LandingPic from "../../assets/landingImage.png";
const index = () => {
  return (
    <div className="homeContainer">
      <div className="homeText">
        <h1>Hello Stranger!</h1>
        <h2 className="webColor">I'm Nikesh Pyakurel</h2>
        <div className="keySkill">
          <div className="keyUnderline"></div>
          <Typical
            steps={[
              "Frontend Developer",
              500,
              "Web Designer",
              500,
              "WordPress Developer",
              500,
              "UI/UX Designer",
              500,

            ]}
            loop={Infinity}
            wrapper="h3"
          />
        </div>
        <div className="socialGroup">
          <a href="https://www.facebook.com/nikeshpyaku">
            <img src={facebook} alt="facebook" />
          </a>
          <a href="https://www.instagram.com/nikesh.pyakurel/">
            <img src={instagram} alt="instagram" />
          </a>
          <a href="https://github.com/nikeshpyakurel">
            <img src={github} alt="github" />
          </a>
        </div>
        <div className="homeBtnGroup">
          <button className="btn1">
            <a href="#home" src="download cv">
              Download CV
            </a>
          </button>
          <button className="btn2">
            <a href="#contact" src="hire me">
              Contact
            </a>
          </button>
        </div>
      </div>
      <div className="homeImage">
        <div className="homeImg">
          <img src={LandingPic} alt="Nikesh Pyakurel" />
        </div>
      </div>
    </div>
  );
};

export default index;
